<div class="waste-info-wrapper fw fh">
    <div class="title-split fw">
        <div class="heading">
            <span>5W1H</span>
        </div>
        <div class="machine-dtls-main fw">
            <div class="machine-id">
                <span>{{machineDtls?.sequenceNumber}}</span>
            </div>
            <div class="machine-name ellipses">
                <span>{{machineDtls?.name}}</span>
            </div>
        </div>
        <div class="close-btn" (click)="closeDialog()" (keydown)="closeDialog()">
        </div>
    </div>
    <div class="content-split">
        <mat-tab-group class="fw fh unilever-tab-grp" (selectedTabChange)="selectedTabChange($event)">
            <mat-tab label="{{'5w1h.add_comment' | translate}}">
                <app-waste-input [machineDtls]="machineDtls"></app-waste-input>
            </mat-tab>
            <mat-tab label="{{'5w1h.past_comments' | translate}}">
                <app-waste-comments-list [commentsList]="commentsList"></app-waste-comments-list>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>